import { EntityMetadata } from '@ngrx/data';
import { HttpResourceUrls } from '@ngrx/data/src/dataservices/http-url-generator';
import { Template } from '../../core/model/central/template.model';

/**
 * Meta data for the entity to be included in the EntityMetadataMap registered in the EntityModule.
 */
export const previewEditTemplateEntityMetadata: EntityMetadata<any> = {
    entityName: 'PreviewEditTemplate',
    selectId: previewEditTemplateSelectId // .id is used if doing optimistic update
};

export const previewEditTemplateHttpResourceUrls: HttpResourceUrls = {
    entityResourceUrl : 'servlets/templates/entity/',
    collectionResourceUrl: 'servlets/templates/entities/'
};

// tslint:disable-next-line:only-arrow-functions typedef
export function previewEditTemplateSelectId<T extends { id: any }>(template: Template) {
    return  template === undefined ? undefined : template.templateId;  // .id is used if doing optimistic update
}
